import { BatteryAlertsContainer } from './batteryAlertsContainer';
import { DeviceAverageDischargeAlertsContainer } from './deviceAverageDischargeAlertsContainer';
import { BatteryHealthChartContainer } from './charts/batteryHealthChartContainer';
import { useFeatureTogglesContext } from '../../../context/featureToggles';
import './style.css';

import { IDevicesAvgDischargeRateIntervalStats, IDevicesAvgDischargeTimeIntervalStats, IDevicesWithCount } from '../../../services/shared/device/batteryDevicesService';
import { BatteryAverageDischargeChartContainer } from './charts/batteryAverageDischargeChartContainer';
import { BatteryCycleCountChartContainer } from './charts/batteryCycleCountChartContainer';
import { BatteryAverageDischargeTimeChartContainer } from './charts/batteryAverageDischargeTimeChartContainer';
import { IBatteriesWithCount, ISmartBatteryAlertCount, ISmartBatteryHealthIntervalStats, ISmartBatteryAvgDischargeIntervalStats, ISmartBatteryFirstSeenIntervalStats, ISmartBatteryBatteryAgeIntervalStats, ISmartBatteryAvgDischargeTimeIntervalStats, ISmartBatteryCycleCountIntervalStats } from '../../../services/shared/battery/batteryCentricService';
import { BatteryFirstSeenChartContainer } from './charts/batteryFirstSeenChartContainer';
import { BatteryAgeChartContainer } from './charts/batteryAgeChartContainer';
import { DeviceAvgDischargeRateChartContainer } from './charts/deviceAvgDischargeRateChartContainer';
import { DeviceAvgDischargeTimeChartContainer } from './charts/deviceAvgDischargeTimeChartContainer';


interface IProps {
  data: {
    batteryEstateData?: IBatteriesWithCount,
    deviceEstateData?: IDevicesWithCount,
    batteryAlertsData?: ISmartBatteryAlertCount,
    batteryHealthIntervalData: ISmartBatteryHealthIntervalStats,
    batteryAverageDischargeData?: ISmartBatteryAvgDischargeIntervalStats,
    batteryFirstSeenData?: ISmartBatteryFirstSeenIntervalStats,
    batteryAgeData?: ISmartBatteryBatteryAgeIntervalStats,
    batteryCycleCountData?: ISmartBatteryCycleCountIntervalStats,
    batteryAverageDischargeTimeData?: ISmartBatteryAvgDischargeTimeIntervalStats,
    deviceAvgDischargeTimeData?: IDevicesAvgDischargeTimeIntervalStats,
    deviceAvgDischargeRateData?: IDevicesAvgDischargeRateIntervalStats
  },
  isBatteryEssentials: boolean,
  isBatteryEssentialsDevices: boolean,
  isLoading?: boolean
}

export const BatteryOverviewChartsContainer = (props: IProps) => {

  return (
    <div>
      <div className="battery-device-chart-container">
        {props.isBatteryEssentials && <BatteryAlertsContainer
          data={props?.data.batteryEstateData}
          isLoading={props.isLoading}
          batteryAlerts={props?.data.batteryAlertsData}
        />}
        {props.isBatteryEssentialsDevices && <DeviceAverageDischargeAlertsContainer
          data={props.data.deviceEstateData}
          isLoading={props.isLoading}
        />}
      </div>
      <div className="battery-overview-chart-first-row">
        {props.isBatteryEssentials && <BatteryAverageDischargeChartContainer
          data={props?.data.batteryAverageDischargeData}
          isLoading={props.isLoading}
        />}
        {props.isBatteryEssentials && <BatteryAverageDischargeTimeChartContainer
          data={props?.data.batteryAverageDischargeTimeData}
          isLoading={props.isLoading}
        />}
      </div>
      <div className="battery-overview-chart-second-row">
        {props.isBatteryEssentialsDevices && <DeviceAvgDischargeRateChartContainer
          data={props?.data.deviceAvgDischargeRateData}
          isLoading={props.isLoading}
        />}
        {props.isBatteryEssentialsDevices && <DeviceAvgDischargeTimeChartContainer
          data={props?.data.deviceAvgDischargeTimeData}
          isLoading={props.isLoading}
        />}
      </div>
      <div className="battery-overview-chart-third-row">
        {props.isBatteryEssentials && <BatteryHealthChartContainer
          data={props?.data.batteryHealthIntervalData}
          isLoading={props.isLoading}
        />}
        {props.isBatteryEssentials && <BatteryCycleCountChartContainer
          data={props?.data.batteryCycleCountData}
          isLoading={props.isLoading}
        />}
      </div>
      <div className="battery-overview-chart-fourth-row">
        {props.isBatteryEssentials && <BatteryFirstSeenChartContainer
          data={props?.data.batteryFirstSeenData}
          isLoading={props.isLoading}
        />}
        {props.isBatteryEssentials && <BatteryAgeChartContainer
          data={props?.data.batteryAgeData}
          isLoading={props.isLoading}
        />}
      </div>
    </div>
  );
};
